import {
  useNavigate,
  useLocation,
  useParams,
  matchPath,
  generatePath,
} from 'react-router-dom';
import { useCallback } from 'react';
import { routes } from '../routes';

export function useUrlUpdater() {
  const location = useLocation();
  const params = useParams();
  const navigate = useNavigate();

  const updateParams = useCallback(
    (newParams) => {
      if (location.pathname.startsWith('/admin')) return;

      const active = routes.find((route) =>
        matchPath(route, location.pathname),
      );

      if (active) {
        const newPath = generatePath(active.path, { ...params, ...newParams });
        if (newPath !== location.pathname) navigate(newPath, { replace: true });
      }
    },
    [location.pathname, navigate, params],
  );

  return { updateParams };
}
